import React from "react";
import data from "../lottie/pptCreateLoading.json";
import { FetchLoading } from "./index";

export const PPTCreateLoading: React.FC<{ width?: number }> = React.memo(
  ({ width }) => {
    return <FetchLoading animationData={data} width={width} />;
  }
);

PPTCreateLoading.displayName = "PPTCreateLoading";
